define(function (require) {
	"use strict";

	var LE = require("app");
	var template = require("user-management-templates/lobs/lobsGridView.tmpl");
	var LobsGridRowView = require("user-management-views/lobs/LobsGridRowView");
	var LobsGridEmptyView = require("user-management-views/lobs/LobsGridEmptyView");

	var LobsGridView = {};

	function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

		LobsGridView = Marionette.GridView.extend({
			className: "table-main ui-table",
			template: template,
			itemViewContainer: "tbody",
			itemView: LobsGridRowView,
			emptyView: LobsGridEmptyView,

            ui: {
                numOfUsers: ".num-of-users",
                numOfCampaigns: ".num-of-campaigns",
                numOfSkills: ".num-of-skills",
                numOfContents: ".num-of-contents"
            },

            onRender: function() {
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    this.ui.numOfUsers.removeClass("hide");
                    this.ui.numOfSkills.removeClass("hide");
                    this.ui.numOfContents.removeClass("hide");
                }
            },

			onCompositeCollectionRendered:function(){
				_.each(this.collection.getSelected(), function(selectedModel){
					if (!_.isEmpty(this.children.findByModel(selectedModel))) {
						selectedModel.trigger("model:selection:change", true);
					}
				}, this);
			}
		});

	}

	LE.module("LEUserManagement", moduleDefinition);

	return LobsGridView;
});
